// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appointment-list-page {
  padding: 2rem;
  background-color: #f9f9f9;
}

.appointment-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e0e0e0;
}

.appointment-list-header h1 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.8rem;
  font-weight: 600;
}

.filters-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  align-items: center;
  margin-bottom: 2rem;
  background-color: white;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.search-container {
  flex: 1 1 300px;
  min-width: 250px;
}

.search-input {
  width: 100%;
  padding: 0.6rem 0.8rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.95rem;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 0 0 auto;
}

.filter-group label {
  font-weight: 500;
  color: #555;
  font-size: 0.9rem;
}

.filter-select {
  padding: 0.6rem 0.8rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.95rem;
  background-color: white;
  min-width: 150px;
}

.appointments-table-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: auto;
}

.appointments-table {
  width: 100%;
  border-collapse: collapse;
}

.appointments-table th,
.appointments-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: middle;
}

.appointments-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.appointments-table tr:last-child td {
  border-bottom: none;
}

.appointments-table tr:hover {
  background-color: #f1f3f5;
}

.status-badge {
  padding: 0.3rem 0.6rem;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  display: inline-block;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 80px;
  text-align: center;
}

.status-pending {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
}

.status-confirmed {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.status-cancelled {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.status-completed {
  background-color: #e2e3e5;
  color: #383d41;
  border: 1px solid #d6d8db;
}

.communication-status {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  justify-content: center;
  min-width: 60px;
}

.comm-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 0.7rem;
  font-weight: bold;
}

.comm-success {
  background-color: #28a745;
  color: white;
}

.comm-failed {
  background-color: #dc3545;
  color: white;
}

.comm-pending {
  background-color: #ffc107;
  color: #212529;
}

.comm-inactive {
  background-color: #e2e3e5;
  color: #383d41;
}

.action-buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}

.btn {
  display: inline-block;
  font-weight: 500;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.5rem 0.9rem;
  font-size: 0.85rem;
  border-radius: 4px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  text-decoration: none;
}

.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:hover {
  color: #fff;
  background-color: #0056b3;
  border-color: #0056b3;
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-secondary:hover {
  color: #fff;
  background-color: #5a6268;
  border-color: #545b62;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  border-radius: 3px;
}

.btn-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}

.btn-danger:hover {
  color: #fff;
  background-color: #c82333;
  border-color: #bd2130;
}

.appointment-list-header .btn-primary {
  padding: 0.6rem 1.2rem;
  font-size: 0.9rem;
}

.no-appointments {
  text-align: center;
  padding: 4rem 2rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  margin-top: 2rem;
  color: #6c757d;
}

.no-appointments p {
  margin: 0;
  font-size: 1.1rem;
  color: #6c757d;
  font-style: italic;
}

.appointment-grid {
  display: block; /* Force l'affichage en bloc, empilant les enfants verticalement */
  width: 100%;   /* Assure que le conteneur prend toute la largeur */
  margin-top: 1rem; /* Ajoute un espace au-dessus de la liste */
}

.loading, .error {
  text-align: center;
  padding: 2rem;
  font-size: 1.2rem;
  color: #6c757d;
}

.error {
  color: #dc3545;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AppointmentList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,qIAAqI;EACrI,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,kEAAkE;EAClF,WAAW,IAAI,mDAAmD;EAClE,gBAAgB,EAAE,2CAA2C;AAC/D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".appointment-list-page {\n  padding: 2rem;\n  background-color: #f9f9f9;\n}\n\n.appointment-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.appointment-list-header h1 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n\n.filters-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  align-items: center;\n  margin-bottom: 2rem;\n  background-color: white;\n  padding: 1rem 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.search-container {\n  flex: 1 1 300px;\n  min-width: 250px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 0.6rem 0.8rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 0.95rem;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex: 0 0 auto;\n}\n\n.filter-group label {\n  font-weight: 500;\n  color: #555;\n  font-size: 0.9rem;\n}\n\n.filter-select {\n  padding: 0.6rem 0.8rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 0.95rem;\n  background-color: white;\n  min-width: 150px;\n}\n\n.appointments-table-container {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  overflow: auto;\n}\n\n.appointments-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.appointments-table th,\n.appointments-table td {\n  padding: 1rem;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n  vertical-align: middle;\n}\n\n.appointments-table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  color: #495057;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.appointments-table tr:last-child td {\n  border-bottom: none;\n}\n\n.appointments-table tr:hover {\n  background-color: #f1f3f5;\n}\n\n.status-badge {\n  padding: 0.3rem 0.6rem;\n  border-radius: 12px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  display: inline-block;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  min-width: 80px;\n  text-align: center;\n}\n\n.status-pending {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeeba;\n}\n\n.status-confirmed {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.status-cancelled {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.status-completed {\n  background-color: #e2e3e5;\n  color: #383d41;\n  border: 1px solid #d6d8db;\n}\n\n.communication-status {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  justify-content: center;\n  min-width: 60px;\n}\n\n.comm-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  font-size: 0.7rem;\n  font-weight: bold;\n}\n\n.comm-success {\n  background-color: #28a745;\n  color: white;\n}\n\n.comm-failed {\n  background-color: #dc3545;\n  color: white;\n}\n\n.comm-pending {\n  background-color: #ffc107;\n  color: #212529;\n}\n\n.comm-inactive {\n  background-color: #e2e3e5;\n  color: #383d41;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: flex-end;\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 500;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.5rem 0.9rem;\n  font-size: 0.85rem;\n  border-radius: 4px;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  text-decoration: none;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n\n.btn-primary:hover {\n  color: #fff;\n  background-color: #0056b3;\n  border-color: #0056b3;\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-secondary:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n\n.btn-sm {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  border-radius: 3px;\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #dc3545;\n  border-color: #dc3545;\n}\n\n.btn-danger:hover {\n  color: #fff;\n  background-color: #c82333;\n  border-color: #bd2130;\n}\n\n.appointment-list-header .btn-primary {\n  padding: 0.6rem 1.2rem;\n  font-size: 0.9rem;\n}\n\n.no-appointments {\n  text-align: center;\n  padding: 4rem 2rem;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  margin-top: 2rem;\n  color: #6c757d;\n}\n\n.no-appointments p {\n  margin: 0;\n  font-size: 1.1rem;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.appointment-grid {\n  display: block; /* Force l'affichage en bloc, empilant les enfants verticalement */\n  width: 100%;   /* Assure que le conteneur prend toute la largeur */\n  margin-top: 1rem; /* Ajoute un espace au-dessus de la liste */\n}\n\n.loading, .error {\n  text-align: center;\n  padding: 2rem;\n  font-size: 1.2rem;\n  color: #6c757d;\n}\n\n.error {\n  color: #dc3545;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
